"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.addressOf = exports.hexify = exports.encodedPubKeyName = exports.signerPubKey = exports.walletPubKey = void 0;
var keys_1 = require("@ew-did-registry/keys");
var ethers_1 = require("ethers");
var did_resolver_interface_1 = require("@ew-did-registry/did-resolver-interface");
var did_1 = require("@ew-did-registry/did");
var keccak256 = ethers_1.utils.keccak256, hashMessage = ethers_1.utils.hashMessage, arrayify = ethers_1.utils.arrayify, computePublicKey = ethers_1.utils.computePublicKey, recoverPublicKey = ethers_1.utils.recoverPublicKey;
exports.walletPubKey = function (_a) {
    var privateKey = _a.privateKey;
    return new keys_1.Keys({ privateKey: privateKey.slice(2) }).publicKey;
};
function signerPubKey(signer) {
    return __awaiter(this, void 0, void 0, function () {
        var msg, hash, digest, signature;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    msg = 'Hello';
                    hash = keccak256(msg);
                    digest = hashMessage(arrayify(hash));
                    return [4 /*yield*/, signer.signMessage(arrayify(digest))];
                case 1:
                    signature = _a.sent();
                    return [2 /*return*/, computePublicKey(recoverPublicKey(digest, signature), true).slice(2)];
            }
        });
    });
}
exports.signerPubKey = signerPubKey;
function encodedPubKeyName(encoding) {
    switch (encoding) {
        case did_resolver_interface_1.Encoding.HEX:
            return 'publicKeyHex';
        case did_resolver_interface_1.Encoding.BASE64:
            return 'publicKeyBase64';
        case did_resolver_interface_1.Encoding.PEM:
            return 'publicKeyPem';
        default:
            return 'publicKeyHex';
    }
}
exports.encodedPubKeyName = encodedPubKeyName;
function hexify(value) {
    if (typeof value === 'string' && value.startsWith('0x')) {
        return value;
    }
    return "0x" + Buffer.from(typeof value === 'string'
        ? value
        : JSON.stringify(value))
        .toString('hex');
}
exports.hexify = hexify;
/**
* Checks if did is valid, and returns the address if it is
*
* @param did
* @private
*/
function addressOf(did) {
    var match = did.match(did_1.DIDPattern);
    if (!match) {
        throw new Error('Invalid DID');
    }
    return match[1];
}
exports.addressOf = addressOf;
//# sourceMappingURL=crypto.js.map